import IconContainer, { IconContainerProps } from "./IconContainer"

export default function IconEdit(props: IconContainerProps) {
    return <IconContainer {...props}>
        edit_note
    </IconContainer>
}
